import { CheckCircleIcon as CheckIconFilled } from "@heroicons/react/24/solid";
import { CheckCircleIcon as CheckIconOutlined } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { Transition } from "@headlessui/react";
type SelectableBadgeProps = {
  text?: string;
  fallbackText?: string;
  selected: boolean;
  onSelect: () => void;
};

function SelectableBadge({
  text,
  fallbackText,
  selected,
  onSelect,
}: SelectableBadgeProps) {
  return (
    <Transition show appear>
      <button
        type="button"
        id="badge-dismiss-default"
        className={clsx(
          "inline-flex items-center p-1  px-2 text-xs font-medium rounded-full gap-1",
          "transition data-[closed]:scale-50 data-[closed]:opacity-0",
          selected && " bg-green-900 text-green-300",
          !selected && "bg-gray-700 text-gray-300"
        )}
        onClick={onSelect}
      >
        {selected ? (
          <CheckIconFilled className="h-4 w-4" />
        ) : (
          <CheckIconOutlined className="h-4 w-4" />
        )}

        <div>
          {text ? (
            <span>{text}</span>
          ) : (
            <p className="text-1.5xs">{fallbackText}</p>
          )}
        </div>
      </button>
    </Transition>
  );
}

export default SelectableBadge;
